import { useStore } from '@betgames/bg-state-manager';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { recentBetsStore, recentBetsSelectors } from '@bg-shared/business/RecentBets';
import { stagedBetsStore, stagedBetsSelectors } from '@bg-shared/business/StagedBets';
import { useMatchedGameId } from '@bg-shared/hooks/useGameId';

export const useAnyBetsPlaced = (): {
    otherGamesHaveBets: boolean;
    currentGameHasBets: boolean;
} => {
    const gameId = useMatchedGameId();
    const activeChipsGames = useStore(stagedBetsStore, stagedBetsSelectors.getActiveChipsGameIds);
    const activeBetsGames = useStore(recentBetsStore, recentBetsSelectors.getActiveBetsGameIds);

    if (!partnerSettingsStore.isUnitedKingdomMarket) {
        return {
            otherGamesHaveBets: false,
            currentGameHasBets: false,
        };
    }

    return {
        otherGamesHaveBets: !!new Set(
            [...activeBetsGames, ...activeChipsGames].filter(
                (activeBetGameId) => activeBetGameId !== gameId,
            ),
        ).size,
        currentGameHasBets: activeBetsGames.includes(gameId) || activeChipsGames.includes(gameId),
    };
};
